// @ts-nocheck
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isValidEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function extractJsonFromString(text: string): any | null {
  try {
    // Look for JSON object at the end of the text
    const jsonMatch = text.match(/\{[\s\S]*\}$/);
    if (jsonMatch) {
      return JSON.parse(jsonMatch[0]);
    }
    
    // Look for any JSON object in the text
    const anyJsonMatch = text.match(/\{[\s\S]*\}/);
    if (anyJsonMatch) {
      return JSON.parse(anyJsonMatch[0]);
    }
    
    return null;
  } catch (error) {
    console.error('Failed to extract JSON:', error);
    return null;
  }
}

export function generateId(): string {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
}

export function formatDate(date: Date | string): string {
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatNumber(num: number): string {
  return new Intl.NumberFormat('en-US').format(num);
}

export function truncateText(text: string, length: number): string {
  if (text.length <= length) return text;
  return text.slice(0, length) + '...';
}